import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import invariant from "ts-invariant";

import { getTokenState } from "@/stores/tokenStore";

const GRAPHQL_URI = import.meta.env.VITE_GRAPHQL_URI as string;
invariant(GRAPHQL_URI, "import.meta.env.VITE_GRAPHQL_URI is not defined");

const httpLink = createHttpLink({ uri: GRAPHQL_URI });

const authLink = setContext((_, { headers }) => {
  const { token, uid, client } = getTokenState();
  return {
    headers: {
      ...headers,
      "access-token": token,
      client,
      uid,
    },
  };
});

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});
